import React from 'react';
import {
  CloseButton,
  CloseButtonIcon,
  Container,
  Content,
  ModalContainer,
  ModalFooter,
  StationsList,
  Subtitle,
  Title,
  TitleInfo,
} from './styles';
import {StationItem} from '../../../../components/shared/Stations/StationItem';
import {StationDTO} from '../../../..//dtos/StationDTO';
import {Button} from '../../../Interface/Forms/Buttons/Button';

import {SafeAreaView} from 'react-native-safe-area-context';
import {RFValue} from 'react-native-responsive-fontsize';

interface Params {
  data: StationDTO[];
  tipo: string;
  showModal: boolean;
  showRank: boolean;
  onDismiss: () => void;
}

export function StationsModal({
  showModal,
  onDismiss,
  data,
  tipo,
  showRank,
}: Params) {
  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      <ModalContainer>
        <Content>
          <CloseButton onPress={onDismiss} activeOpacity={0.7}>
            <CloseButtonIcon name="x" />
          </CloseButton>
          <TitleInfo>
            <Title>
              {tipo === 'C'
                ? 'Abasteça em qualquer um desses postos:'
                : 'Retire em qualquer um desses locais:'}
            </Title>
            <Subtitle>
              Locais para abastecer ou retirar o seu produto/serviço
            </Subtitle>
          </TitleInfo>

          <StationsList
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{paddingBottom: RFValue(20)}}>
            {data.map(item => (
              <StationItem
                data={item}
                actionBeforeNavigate={onDismiss}
                key={item.id}
                showRank={showRank ? true : false}
              />
            ))}
          </StationsList>
        </Content>
        <ModalFooter>
          <SafeAreaView>
            <Button title="Retornar" enabled onPress={onDismiss} variant="outline" />
          </SafeAreaView>
        </ModalFooter>
      </ModalContainer>
    </Container>
  );
}
